import { render, staticRenderFns } from "./LinkForm.vue?vue&type=template&id=be26086c&scoped=true"
import script from "./LinkForm.ts?vue&type=script&lang=ts&external"
export * from "./LinkForm.ts?vue&type=script&lang=ts&external"
import style0 from "./LinkForm.scss?vue&type=style&index=0&id=be26086c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be26086c",
  null
  
)

export default component.exports